import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, TruckIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" data-id="element-115">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-116">
        <Link to="/" className="flex items-center space-x-2" data-id="element-117">
          <TruckIcon className="h-6 w-6 text-primary" data-id="element-118" />
          <span className="font-bold text-xl tracking-tight text-foreground" data-id="element-119">
            Universal Global Logistics
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-120">
          {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-primary ${isActive(link.path) ? 'text-primary' : 'text-muted-foreground'}`} data-id="element-121">
              {link.name}
            </Link>)}
          <Link to="/quote" data-id="element-122">
            <Button variant="primary" data-id="element-123">Get a Quote</Button>
          </Link>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 text-foreground" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-124">
          {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-125" /> : <MenuIcon className="h-6 w-6" data-id="element-126" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden border-t bg-background" data-id="element-127">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-128">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium p-2 rounded-md ${isActive(link.path) ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-129">
                {link.name}
              </Link>)}
            <Link to="/quote" onClick={() => setIsMobileMenuOpen(false)} data-id="element-130">
              <Button variant="primary" className="w-full" data-id="element-131">
                Get a Quote
              </Button>
            </Link>
          </nav>
        </div>}
    </header>;
}